import { FaUser } from "react-icons/fa";
import style from "./style.module.css";
import { creatorListApi, creatorsDelete } from "../../api/HttpApis";
import Button from "../../component/button/Button";
import { showToast } from "../../utils/Toastify/Toastify";

export const CreatorListData = async (limit, page, searchQuery) => {
    const perpage = Number(limit) || 10;
    const currentPage = Number(page) || 1;
    const search = searchQuery;

    const response = await creatorListApi({}, perpage, currentPage, search);
  // const response = await creatorListApi({}, limit,page, searchQuery);
  const data = Array.isArray(response?.data?.data) ? response.data.data : [];
  return data.map((creator) => ({
    id: creator?.id,
    name: creator?.name,
    email: creator?.email,
    contributions: creator.contributions,
    lastSubmissions:
      creator?.last_submission?.trim() !== "" ? creator.last_submission : "N/A",
    dateAdded: creator?.data_added,
    icon: creator?.profile_img,
    status: creator?.status,
    totalCount: response?.data?.total,
  }));
};


export const getColumns = (handleDelete, deletingId, handleEdit) => [
  {
    key: "icon",
    label: "",
    render: (creator) => (
      <div>
        {creator.icon ? (
          <img
            src={creator.icon}
            alt={creator.name}
            className={style.IconBackground}
            onError={(e) => {
              e.currentTarget.onerror = null;
              e.currentTarget.style.display = "none";
              const fallback = e.currentTarget.nextElementSibling;
              if (fallback) fallback.style.display = "";
            }}
          />
        ) : null}
        <div
          className={style.IconBackground}
          style={creator.icon ? { display: "none" } : undefined}
        >
          <FaUser className={style.searchIconSize} />
        </div>
      </div>
    ),
  },
  {
    key: "name",
    label: "Name",
  },
  {
    key: "email",
    label: "Email",
    render: (creator) => (
      <span style={{ textDecoration: "underline" }}>{creator.email}</span>
    ),
  },
  {
    key: "contributions",
    label: "No. of Contributions",
  },
  {
    key: "lastSubmissions",
    label: "Last Submission",
  },
  {
    key: "dateAdded",
    label: "Date Added",
  },
  {
    key: "delete",
    label: "Action",
    render: (item) => (
      <Button
        variant="text"
        className={style.deleteButton}
        onClick={() => handleDelete(item.id)}
      >
        Delete
      </Button>
    ),
  },
];